import { Modal, Button } from "react-bootstrap";

const AppModal = ({
  size,
  show,
  handleClose,
  modalTitle,
  children,
  buttons,
  onSubmit,
  currentId,
  closeButton = true,
  onOpen,
  disabledFunctional,
  disabledSubmit,
  confirmText = "Подтвердить",
  editText = "Изменить",
  closeText = "Закрыть",
  preventOutsideClose = false,
  hideFooter = false,
  // Необязательные расширения; существующие вызовы сохраняют прежнее поведение.
  footer,
  className,
  dialogClassName = '',
  contentClassName = '',
  backdropClassName = '',
  bodyClassName,
  keyboard,
  titleId,

}) => {
  const handleSubmit = () => {
    if (disabledSubmit) return alert("нужно заполнить все");
    onSubmit && onSubmit();
  };

  return (
    <Modal
      size={size}
      show={show}
      onHide={handleClose}
      onShow={onOpen}
      centered
      scrollable
      backdrop={preventOutsideClose ? "static" : true}
      keyboard={keyboard ?? !preventOutsideClose}
      className={className}
      dialogClassName={['appModalDialog', dialogClassName].filter(Boolean).join(' ')}
      contentClassName={['appModalContent', contentClassName].filter(Boolean).join(' ')}
      backdropClassName={['appModalBackdrop', backdropClassName].filter(Boolean).join(' ')}
      aria-labelledby={titleId}
    >
      {modalTitle ? (
        <Modal.Header closeButton={closeButton}>
          <Modal.Title id={titleId}>{modalTitle}</Modal.Title>
        </Modal.Header>
      ) : null}

      <Modal.Body className={bodyClassName}>{children}</Modal.Body>

      {!hideFooter ? (
        <Modal.Footer>
          {footer !== undefined ? footer : buttons ? (
            buttons.map((btn, index) => (
              <Button key={index} variant={btn.color} onClick={btn.onClick} disabled={Boolean(btn.disabled)}>
                {btn.label}
              </Button>
            ))
          ) : (
            <>
              <Button variant="secondary" className="btn-sm" onClick={handleClose}>
                {closeText}
              </Button>
              {disabledFunctional ? null : (
                <Button
                  disabled={disabledSubmit}
                  variant="dark"
                  className="btn-sm"
                  onClick={handleSubmit}
                >
                  {!currentId ? confirmText : editText}
                </Button>
              )}
            </>
          )}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default AppModal;
